import React from 'react'
import { Link } from 'gatsby'
import { render, MARK_LINK, NODE_HEADING, NODE_PARAGRAPH, NODE_LI, NODE_UL, NODE_OL, NODE_QUOTE, MARK_ITALIC } from 'storyblok-rich-text-react-renderer'

import ButtonPrimary from './../ButtonPrimary'
import Banner from './../Banner'
import Quote from './../Quote'
import Image from './../Image'
import List from './../List'
import MenuDropdown from './../MenuDropdown'
import ImageCaption from './../ImageCaption'

import styles from './styles.module.scss'

const TextRenderer = ({ text, className, style }) => {
    return (
        <div className={className} style={style}>
            {render(text, {
                nodeResolvers: {
                    [NODE_HEADING]: (children, { level }) => {
                        return (
                            <p className={`heading-${level}`} style={{ color: 'currentColor' }}>{children}</p>
                        )
                    },
                    [NODE_PARAGRAPH]: (children) => {
                        return (
                            <p className='body' style={{ color: 'currentColor' }}>{children}</p>
                        )
                    },
                    [NODE_UL]: (children) => <ul className='list list--unordered'>{children}</ul>,
                    [NODE_OL]: (children) => <ol className='list list--ordered'>{children}</ol>,
                    [NODE_LI]: (children) => <li className='list list-item'>{children}</li>,
                },
                markResolvers: {
                    [MARK_LINK]: (children, props) => {

                        const { href, target, linktype, anchor } = props

                        if (linktype === 'email') {
                            return <a className='link' href={`mailto:${href}`}>{children}</a>
                        }

                        if (href.includes('http')) {
                            return <a className='link' href={href} target={target || '_blank'}>{children}</a>
                        }

                        let url = anchor ? `${href}#${anchor}` : href

                        return <Link className='link' to={url}>{children}</Link>
                    },
                    [MARK_ITALIC]: (children) => <span className='footnote'>{children}</span>
                },
                blokResolvers: {
                    ['button']: (props) => {
                        return <ButtonPrimary {...props} className={styles['text__button']} />
                    },
                    ['banner']: (props) => {
                        return <Banner blok={props} params={{ maxWidth: 500 }} />
                    },
                    ['quote']: (props) => {
                        return <Quote blok={props} />
                    },
                    ['list']: (props) => {
                        return <List blok={props}/>
                    },
                    ['menu_dropdown']: (props) => {
                        return <MenuDropdown blok={props} />
                    },
                    ['image']: (props) => {
                        return (
                            <>
                                <img src={props.asset.filename} className={styles['text__image']} />
                                {props.caption && (
                                    <ImageCaption props={props} />
                                )}
                            </>
                        )
                    }
                }
            })}
        </div>
    )
}

export default TextRenderer